export function checkInjectTarget(id='nit-alme-window-root', className='ask-julie-embed') {
    const target = document.getElementById(id);

    return {
        onContactUsPage: !!target && target.className.includes(className) > -1,
    };
}

export default {
    checkInjectTarget,
};


// WEBPACK FOOTER //
// ./src/util.js